import { Box, Card, CardContent, Grid, Typography } from "@mui/material"
import React, { ChangeEvent } from "react"
import { customPalette } from "../../../../../../../../../../theme"
import { FormNumberInput } from "../../../../../../../../../components/inputs/number-input/FormNumberInput"
import { FormSelectInput } from "../../../../../../../../../components/inputs/select-input/FormSelectInput"
import { BSInput } from "../../../../../../../../../core/dto/beem-shot/BSInput/BSInput"
import { BSInputParkingUpdateDto } from "../../../../../../../../../core/dto/beem-shot/BSInput/BSInputParkingUpdateDto"
import { ParkingEnum, parkingEnumLabels } from "../../../../../../../../../core/enum/beem-shot/ParkingEnum"
import { enumToSelectOptions } from "../../../../../../../../../core/services/helper-service"

export interface IBSInputParkingForm {
  typeParking: ParkingEnum
  nombrePlaceParking: number
  nombreEtageParking: number
}

export function bsInputParkingFormToUpdateDto(form: IBSInputParkingForm, bsInputId: string): BSInputParkingUpdateDto {
  return {
    id: bsInputId,
    typeParking: form.typeParking,
    nombrePlaceParking: form.nombrePlaceParking,
    nombreEtageParking: form.nombreEtageParking,
  }
}

export function bsParkingDtoToForm(dto: BSInput | undefined): IBSInputParkingForm {
  return dto
    ? {
        typeParking: dto.typeParking,
        nombrePlaceParking: dto.nombrePlaceParking,
        nombreEtageParking: dto.nombreEtageParking,
      }
    : ({ typeParking: ParkingEnum.SANS, nombrePlaceParking: 0, nombreEtageParking: 0 } as IBSInputParkingForm)
}

interface IProps {
  title: string
  form: IBSInputParkingForm
  errors: Record<string, string | undefined>
  handleChange?(event: ChangeEvent<HTMLInputElement>): void
}

export function BSInputParkingForm({ title, form, errors, handleChange }: Readonly<IProps>): React.JSX.Element {
  return (
    <Card
      sx={{
        backgroundColor: customPalette.white,
        borderRadius: 3,
        mb: 3,
        boxShadow: "2px 4px 20px 0px rgba(0, 0, 0, 0.05)",
      }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            p: 1,
            mb: 1,
          }}>
          <Typography variant="body2" fontWeight={600} sx={{ color: customPalette.darkBlue2 }}>
            {title}
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              height: "2px",
              backgroundColor: customPalette.lightBlue1,
              marginLeft: "8px",
            }}
          />
        </Box>

        <FormSelectInput
          id="typeParking"
          label="Stationnement"
          mode="event"
          selectedOption={form.typeParking}
          options={enumToSelectOptions(ParkingEnum, parkingEnumLabels)}
          handleEventChange={handleChange}
          errors={errors}
        />

        {(form.typeParking === ParkingEnum.SOUTERRAIN || form.typeParking === ParkingEnum.SUPER_STRUCTURE) && (
          <Grid container columnSpacing={1}>
            <Grid item xs={6}>
              <FormNumberInput
                fieldName="nombreEtageParking"
                label="Nombre de niveaux"
                handleEventChange={handleChange}
                value={form.nombreEtageParking}
                errors={errors}
              />
            </Grid>
            <Grid item xs={6}>
              <FormNumberInput
                fieldName="nombrePlaceParking"
                label="Nombre de places"
                handleEventChange={handleChange}
                value={form.nombrePlaceParking}
                errors={errors}
              />
            </Grid>
          </Grid>
        )}

        {form.typeParking === ParkingEnum.EXTERIEUR && (
          <Grid item xs={6}>
            <FormNumberInput
              fieldName="nombrePlaceParking"
              label="Nombre de places"
              handleEventChange={handleChange}
              value={form.nombrePlaceParking}
              errors={errors}
            />
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}
